module.exports = __webpack_public_path__ + "static/media/upload_more.7ff207c1.svg";